import PropTypes from "prop-types";
import { useMemo } from "react";
import Loader from "shared/components/Loader";
import { useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { INITIAL_VALUES } from "../utils/constants";

const Processes = ({ View, filter, ...props }) => {
  const variables = {
    ...filter,
    skip: parseInt(filter.skip) ?? INITIAL_VALUES.skip,
    take: parseInt(filter.take) ?? INITIAL_VALUES.take,
  };
  const query = useQuery(graphql.queries.PROCESSES, {
    variables,
  });
  const WrappedView = useMemo(() => Loader(View), [View]);
  return (
    <WrappedView
      {...{
        ...props,
        ...query,
        type: "processes",
      }}
    />
  );
};

Processes.propTypes = {
  View: PropTypes.func.isRequired,
  filter: PropTypes.object,
};

Processes.defaultProps = {
  filter: {},
};

export default Processes;
